import styled from 'styled-components';

type SpacerProps = {
  em?: number;
  rem?: number;
  px?: number;
};

export const Spacer = styled.div<SpacerProps>`
  ${(props) => props.em && `height: ${props.em}em`};
  ${(props) => props.rem && `height: ${props.rem}rem`};
  ${(props) => props.px && `height: ${props.px}px`};
`;
